// One word per score band, the only place a 1–6 area score is put into words (design V4 of the "Betygsord"
// canvas, 2026-10-31, with Enklare and Ansträngt at the bottom): the search results, the area cards, the listing
// cards, hover cards and popup, the map legend and every score scale (filter, colour menu, FAQ, first-visit
// guide). The score itself compares an area with its nearby areas; the words describe the area's character in an
// order that reads as a ladder, so the same score never gets two words. All are adjectives, so the cards say
// "<word> område"; the search and the list cards give the word alone.

// `svAttr` is the attributive form for the popup's summary ("i eftertraktade Eriksberg"), only the top three.
const BANDS = [
    { min: 5.5, sv: 'Exklusivt', en: 'Exclusive', svAttr: 'exklusiva', enAttr: 'exclusive' },
    { min: 4.5, sv: 'Eftertraktat', en: 'Sought-after', svAttr: 'eftertraktade', enAttr: 'sought-after' },
    { min: 3.5, sv: 'Attraktivt', en: 'Attractive', svAttr: 'attraktiva', enAttr: 'attractive' },
    { min: 2.5, sv: 'Stabilt', en: 'Steady' },
    { min: 1.5, sv: 'Enklare', en: 'Modest' },
    { min: -Infinity, sv: 'Ansträngt', en: 'Strained' },
];

const bandFor = (score) => {
    if (score == null || score === '') return null;
    const value = Number(score);
    if (!Number.isFinite(value)) return null;
    return BANDS.find(({ min }) => value >= min) || null;
};

// The word for a score ('' without one).
export const scoreWord = (score, swedish = true) => bandFor(score)?.[swedish ? 'sv' : 'en'] || '';

// The same word before a place name ("eftertraktade"), from Attraktivt up; '' below it.
export const scoreAdjective = (score, swedish = true) => bandFor(score)?.[swedish ? 'svAttr' : 'enAttr'] || '';

// A 1–6 scale's labels, low to high: its bottom (1), a typical area (3,5) and its top (6).
export const scoreScaleWords = (swedish = true) => [scoreWord(1, swedish), scoreWord(3.5, swedish), scoreWord(6, swedish)];
